<div class="container-dash">
  <div class="row-dash">
    <app-dashboard-navbar></app-dashboard-navbar>
    <div class="main">
      <main>
        <div class="card mt-4">
          <div class="card-header" height="30px">
            Bienvenido al dashboard {{user.userName}}
          </div>
          <div class="card-body">
            <blockquote class="blockquote mb-0">
              <p>En esta seccion encontrarás las publicaciones que has subido</p>
              <footer class="blockquote-footer">Vamos a <cite title="Source Title">romper las redes</cite></footer>
            </blockquote>
          </div>
        </div>
        <div class="card mt-4" *ngIf="trendingTwitter.length > 0">
          <div class="card-header">
            Trending topics de Twitter<span *ngIf="user.country == 'Global'"> {{user.country}}</span><span *ngIf="user.country !== 'Global' && user.country !== undefined"> en {{user.country}}</span>
          </div>
          <div class="card-body">
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-center col-12" *ngFor="let trend of trendingTwitter">
                <a [href]="trend.url" target="_blank">{{ trend.name }}</a>
                <span class="badge badge-primary badge-pill">{{ trend.tweet_volume }}</span>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="card" *ngIf="LoggedTwitter">
          <div class="card-header">
            Estadísticas
          </div>
          <div class="card-body">
            <app-stats></app-stats>
          </div>
        </div>  -->
      </main>
    </div>
  </div>
</div>

<app-footer></app-footer>